export default process.env.REACT_APP_NODE_ENV === "production"
  ? "https://internalexam.vectorindia.org/"
  : "http://localhost:6080";
